<template>
    <b-container fluid>
        <div v-if="!!theMeetings.length">
            <b-row>
                <b-col>

                </b-col>
            </b-row>
            <b-row>
                <b-col
                    ><b-alert show variant="success"
                        >{{ meetings.length }} Reuniones en curso -
                        {{ theParticipants.length }} Participantes Invitados -
                        {{
                            theParticipants.filter((item) => !!item.attend)
                                .length
                        }}
                        Participantes Conectados - Asistencia:
                        {{
                            ((theParticipants.filter((item) => !!item.attend)
                                .length /
                                theParticipants.length) *
                                100)
                                | decimal
                        }}%</b-alert
                    ></b-col
                >
            </b-row>
            <b-table striped :items="theMeetings" :fields="fields">
                <template #cell(participants)="{ item }">
                    {{ item.participants.length }}
                </template>
                <template #cell(connected_participants)="{ item }">
                    {{
                        item.participants.filter((item) => !!item.attend).length
                    }}
                </template>
                <template #cell(start_audience)="{ item }">
                    {{ item.start_audience | decimal }}
                </template>
                <template #cell(current_quorum)="{ item }">
                    {{
                        item.participants
                            .filter((item) => !!item.attend)
                            .reduce(
                                (carry, item) => carry + item.coefficient,
                                0
                            ) | decimal
                    }}
                </template>
            </b-table>
        </div>
        <div v-else>
            <b-alert show variant="info">No hay reuniones en curso</b-alert>
        </div>
    </b-container>
</template>
<script>
import appMeetingFilters from "./MeetingFilters";
export default {
    components: {
        appMeetingFilters
    },
    data: () => ({
        meetings: [],
        participants: [],
        meetingsSync: null,
        participantsSync: null,
        fields,
        participantPages: {},
    }),
    watch: {
        participantPages(val) {
            let participants = []
            Object.keys(this.participantPages).map(
                (key) =>
                    (participants = [
                        ...participants,
                        ...(this.participantPages[key] ?? []),
                    ])
            )
            this.participants = participants
        },
    },
    computed: {
        meetingIds() {
            return this.meetings.map((item) => item.id)
        },
        theMeetings() {
            return this.meetings.map((meeting) => ({
                ...meeting,
                participants: this.participantPages[meeting.id] ?? [],
            }))
        },
        theParticipants() {
            let participants = []
            Object.keys(this.participantPages).map(
                (key) =>
                    (participants = [
                        ...participants,
                        ...(this.participantPages[key] ?? []),
                    ])
            )
            return participants
        },
    },
    methods: {
        syncMeetings() {
            this.meetingsSync = fdb
                .collection('meetings')
                .where('start_date', '>', '')
                .where('end_date', '==', null)
                .onSnapshot((docs) => {
                    const meetings = []
                    docs.forEach((item) => meetings.push(item.data()))
                    this.meetings = meetings
                    this.participantPages = {}
                    this.syncParticipants()
                })
        },
        syncParticipants() {
            const chunk = 10
            let i, j, temparray
            this.participantPages = {}
            for (i = 0, j = this.meetingIds.length; i < j; i += chunk) {
                temparray = this.meetingIds.slice(i, i + chunk)

                this.participantsSync = fdb
                    .collection('meeting_participants')
                    .where('firebase_meeting_id', 'in', temparray)
                    .onSnapshot((docs) => {
                        const participants = []
                        docs.forEach((item) => {
                            const participant = item.data()
                            if (
                                !this.participantPages.hasOwnProperty(
                                    participant.firebase_meeting_id
                                )
                            ) {
                                this.participantPages[
                                    participant.firebase_meeting_id
                                ] = []
                            }
                            this.participantPages[
                                participant.firebase_meeting_id
                            ].push(participant)
                        })
                    })
            }
        },
    },
    created() {
        this.syncMeetings()
    },
}

const fields = [
    {
        key: 'id',
        label: 'ID',
    },
    {
        key: 'name',
        label: 'Reunión',
    },
    {
        key: 'code',
        label: 'Código',
    },
    {
        key: 'host.name',
        label: 'Moderador',
    },
    {
        key: 'meeting_date',
        label: 'Fecha',
    },
    {
        key: 'meeting_type.name',
        label: 'Tipo',
    },
    {
        key: 'participants',
        label: 'Participantes',
    },
    {
        key: 'connected_participants',
        label: 'Conectados',
    },
    {
        key: 'start_audience',
        label: 'Quórum de inicio',
    },
    {
        key: 'current_quorum',
        label: 'Quórum actual',
    },
    {
        key: 'start_date',
        label: 'Fecha de inicio',
    },
]
</script>
